import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const knowbaseApi = createApi({
  reducerPath: 'knowbase',
  tagTypes: ['Knowbase'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchAllKnowbase: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Knowbase', id: 'LIST' },
                ...result.map((r) => ({ type: 'Knowbase', id: r.id })),
              ]
            : [{ type: 'Knowbase', id: 'LIST' }],
        query: (coach) => ({
          url: `?resource=faq&coach=eq.${coach}&order=created_at.asc`,
          method: 'GET',
        }),
      }),

      createKnowbase: builder.mutation({
        invalidatesTags: [{ type: 'Knowbase', id: 'LIST' }],
        query: (data) => ({
          url: '?resource=faq',
          method: 'POST',
          body: data,
        }),
      }),

      updateKnowbase: builder.mutation({
        invalidatesTags: (result, error, { id: knowbaseId }) => [
          { type: 'Knowbase', id: knowbaseId },
          { type: 'Knowbase', id: 'LIST' },
        ],
        query: ({ id: knowbaseId, submitData }) => ({
          url: `?resource=faq&id=eq.${knowbaseId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      fetchKnowbase: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Knowbase', id: arg }],
        query: (knowbaseId) => ({
          url: `?resource=faq&id=eq.${knowbaseId}`,
          method: 'GET',
        }),
      }),

      deleteKnowbase: builder.mutation({
        invalidatesTags: (result, error, id) => [
          { type: 'Knowbase', id },
          { type: 'Knowbase', id: 'LIST' },
        ],
        query: (id) => ({
          url: `?resource=faq&id=eq.${id}`,
          method: 'DELETE',
        }),
      }),
    };
  },
});

export const {
  useFetchAllKnowbaseQuery,
  useCreateKnowbaseMutation,
  useUpdateKnowbaseMutation,
  useFetchKnowbaseQuery,
  useDeleteKnowbaseMutation,
} = knowbaseApi;

export { knowbaseApi };
